import { Button } from 'src/shared/components/ui/buttons/button'
import DashboardModal from 'src/shared/components/ui/dashboard/dashboard-modal'
import ConradInfoTable from 'src/shared/components/ui/info-table/conrad-info-table'

import type { BusinessInfo } from '../schemas/business-create'
import { BusinessInfoIcons, BusinessInfoLabels } from '../schemas/business-create'

type MissingDataModalProps = {
  open: boolean
  onClose: () => void
  missingFields: (keyof BusinessInfo)[]
  onAddManually: () => void
  onLetLynkHandle: () => void
}

const MissingDataModal = ({ open, onClose, missingFields, onAddManually, onLetLynkHandle }: MissingDataModalProps) => {
  const uniqueFields = missingFields.filter((field, index) => missingFields.indexOf(field) === index)

  return (
    <DashboardModal open={open} onClose={onClose}>
      <div className="relative z-[100] flex w-[400px] flex-col gap-6 rounded-[25px] bg-white">
        <div className="flex flex-col gap-4 p-7 text-center">
          <div className="flex flex-col gap-2.5 text-center">
            <h2 className="text-[26px] font-semibold leading-tight text-primary">Info needed to move forward</h2>
            <p className="text-base leading-[1.6] text-muted">
              Because you skipped a previous workflow, Lynk needs this information before moving forward.
            </p>
          </div>

          <div className="max-h-[260px] overflow-y-auto">
            <div className="flex flex-col gap-2">
              {uniqueFields.length === 0 ? null : (
                <ConradInfoTable
                  items={uniqueFields.map((field) => {
                    const BusinessInfoIcon = BusinessInfoIcons[field] || null
                    return {
                      title: BusinessInfoLabels[field] ?? field,
                      leftIcon: <BusinessInfoIcon size={18} color="text-primary" />,
                      hideArrow: true,
                    }
                  })}
                />
              )}
            </div>
          </div>
        </div>

        <div className="flex flex-row justify-end gap-3 border-t border-lightBorder p-5">
          <Button variant="ghost" size="xl" className="rounded-full px-5 text-base" onClick={onAddManually}>
            Add manually
          </Button>
          <Button variant="default" size="xl" className="flex-1 rounded-full px-5 text-base" onClick={onLetLynkHandle}>
            Let Lynk handle
          </Button>
        </div>
      </div>
    </DashboardModal>
  )
}

export default MissingDataModal
